<template>
  <div class="supplier-manage bj">
    <div class="title">
      <div class="form jn-form-style">
        <div class="form-item btn-wrap">
          <el-button
            type="primary"
            style="margin-left: 5px"
            icon="el-icon-refresh"
            class="refresh"
            @click="onHandleRefresh"
          ></el-button>
          <!-- <el-button @click="onHandleCreate" type="primary">新 增</el-button> -->
        </div>

        <div class="form-item">
          <el-select
            v-model="formData.logistic_business_id"
            placeholder="选择集配中心"
            clearable
          >
            <el-option
              v-for="item of logisticsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="form-item">
          <el-input
            v-model="formData.buyer_name"
            placeholder="请输入业务员名称"
            clearable
          ></el-input>
        </div>
        <div class="form-item">
          <el-input
            v-model="formData.team_name"
            placeholder="请输入所属小组"
            clearable
          ></el-input>
        </div>
        <div class="form-item">
          <el-input
            v-model="formData.buyer_mobile"
            placeholder="请输入采购电话"
            clearable
          ></el-input>
        </div>
        <div class="form-item">
          <el-select
            v-model="formData.buyer_state"
            clearable
            placeholder="请选择状态"
          >
            <el-option label="全部状态" value=""></el-option>
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="2"></el-option>
          </el-select>
        </div>
        <div class="form-item">
          <el-input
            v-model="formData.supplier_name"
            placeholder="请输入供应商名称"
            clearable
          ></el-input>
        </div>
        <div class="form-item">
          <el-input
            v-model="formData.supplier_mobile"
            placeholder="请输入供应商电话"
            clearable
          ></el-input>
        </div>

        <el-button @click="onHandleSearch" type="primary" icon="el-icon-search"
          >查询</el-button
        >
        <el-button type="primary" @click="onHandleExport">导 出</el-button>
      </div>
    </div>
    <div class="auto-table-flex">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column type="index" width="80px" align="center" label="序号">
        </el-table-column>
        <el-table-column prop="buyer_name" align="center" label="业务员">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.buyer.fullname) }}
          </template>
        </el-table-column>
        <el-table-column prop="supplier_name" align="center" label="发品供应商">
          <template slot-scope="scope">
            {{ $empty.empty(scope.row.supplier.title) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="onsale_num"
          align="center"
          label="在售商品数量"
        ></el-table-column>
        <el-table-column
          prop="outsale_num"
          align="center"
          label="下架商品数量"
        ></el-table-column>
        <el-table-column
          prop="sit_text"
          align="center"
          label="是否限制坑位"
        ></el-table-column>
        <el-table-column
          prop="sit_num"
          align="center"
          label="坑位数"
        ></el-table-column>
        <el-table-column
          prop="stock_add"
          align="center"
          label="加库存"
        ></el-table-column>
        <el-table-column
          prop="stock_sub"
          align="center"
          label="减库存"
        ></el-table-column>
        <el-table-column
          prop="offline"
          align="center"
          label="下架商品"
        ></el-table-column>
        <el-table-column
          prop="create_sku"
          align="center"
          label="新建商品"
        ></el-table-column>
        <el-table-column
          prop="edit_sku"
          align="center"
          label="编辑商品"
        ></el-table-column>
        <el-table-column
          prop="change_pic"
          align="center"
          label="换图"
        ></el-table-column>

        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="onHandleEdit(scope.row)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="editDialogVisible"
      v-if="editDialogVisible"
      width="50%"
      class="dialog supplier-dialog"
      center
    >
      <div class="contents">
        <!-- 基础信息 -->
        <div class="info-section">
          <div class="info-title">基础信息</div>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">供应商：</span>
              <span class="info-value"
                >{{ editForm.supplier_name }}【{{
                  editForm.supplier_mobile
                }}】</span
              >
            </div>
            <div class="info-item">
              <span class="info-label">采购：</span>
              <span class="info-value"
                >{{ editForm.buyer_name }}【{{ editForm.buyer_mobile }}】</span
              >
            </div>
            <div class="info-item">
              <span class="info-label">在售商品：</span>
              <span class="info-value">{{ editForm.on_sale_count }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">下架商品：</span>
              <span class="info-value">{{ editForm.off_sale_count }}</span>
            </div>
          </div>
        </div>

        <!-- 权限配置 -->
        <div class="auth-section">
          <!-- <div class="auth-title">权限配置</div> -->
          <div class="auth-list">
            <div
              v-for="(item, index) in authConfigList"
              :key="index"
              class="auth-item"
            >
              <div class="auth-row">
                <span class="auth-name-label">{{ item.name }}：</span>
                <el-radio-group v-model="item.value" size="small">
                  <el-radio
                    @input.native="
                      (data) => {
                        changeInput(data, item);
                      }
                    "
                    v-for="opt in item.options"
                    :key="opt.value"
                    :label="opt.value"
                  >
                    {{ opt.label }}
                  </el-radio>
                </el-radio-group>
                <div class="auth-options">
                  <el-checkbox v-model="item.allowChange" size="small">
                    允许采购更改
                  </el-checkbox>
                  <el-checkbox v-model="item.applyAll" size="small">
                    应用于该采购全部供应商
                  </el-checkbox>
                </div>
              </div>
              <!-- 坑位数单独一行 -->
              <div v-if="item.auth_type === '1'" class="slot-row">
                <span class="slot-label">坑位数：</span>
                <el-input
                  v-model="editForm.slot_count"
                  :disabled="item.value === 0"
                  placeholder="请输入坑位数"
                  class="slot-input"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onHandleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import cloneDeep from "lodash/cloneDeep";
import { skusupplierexport } from "@/api/export/index.js";
import { downLoadFlowBlob } from "@/utils/tools/base";

export default {
  name: "JiCaiSupplierManage",
  data() {
    return {
      loading: false,
      logisticsList: [], // 集配中心列表
      formData: {
        logistic_business_id: "",
        buyer_name: "",
        team_name: "",
        buyer_mobile: "",
        buyer_state: "",
        supplier_name: "",
        supplier_mobile: "",
        page: 1,
        pageSize: 100,
      },
      formDataClone: {},
      tableData: [],
      currentPage: 1,
      total: 0,
      dialogTitle: "新增",
      editDialogVisible: false,
      disabledExport: false,
      editForm: {
        supplier_id: "",
        buyer_id: "",
        supplier_name: "",
        buyer_name: "",
        supplier_mobile: "",
        buyer_mobile: "",
        on_sale_count: "",
        off_sale_count: "",
        slot_count: 0,
      },
      editFormClone: {},
      authConfigList: [], // 动态权限配置列表
    };
  },
  mounted() {
    this.formDataClone = cloneDeep(this.formData);
    console.log("object", this.$route);
    this.formData.buyer_name = this.$route.query.buyer_name;
    this.editFormClone = cloneDeep(this.editForm);
    this.initAuthConfigList();
    this.getTableData();
    this.getAjaxLogisticsList();
  },
  methods: {
    /**
     * 初始化权限配置列表
     */
    initAuthConfigList() {
      this.authConfigList = [];
    },
    /**
     * 从接口数据动态构建权限配置列表
     */
    buildAuthConfigList(authData) {
      this.authConfigList = [];
      if (!authData) return;

      // 遍历接口返回的 auth 对象，动态构建配置列表
      Object.keys(authData).forEach((key) => {
        const item = authData[key];
        const authType = String(item.auth_type);

        // 根据 auth_type 确定选项
        let options, value, showSlotInput;
        if (authType === "1") {
          // 是否限制坑位
          options = [
            { label: "是", value: 1 },
            { label: "否", value: 0 },
          ];
          // auth_value: 0 不限制, >=1 限制
          value = item.auth_value == 0 || Number(item.auth_value) > 0 ? 1 : 0;
          showSlotInput = true;
        } else {
          // 其他权限
          options = [
            { label: "允许", value: 1 },
            { label: "不允许", value: -1 },
          ];
          // auth_value: -1 不允许, 1 允许
          value = Number(item.auth_value) > 0 ? 1 : -1;
          showSlotInput = false;
        }

        this.authConfigList.push({
          auth_type: authType,
          name: item.auth_name || "",
          options,
          value,
          showSlotInput,
          allowChange: Number(item.buyer_set) > 0,
          applyAll: Number(item.is_batch) > 0,
          // 保存原始值用于提交
          originalAuthValue: item.auth_value,
        });
      });
    },
    /**
     * 获取集配中心列表
     */
    async getAjaxLogisticsList() {
      try {
        const { data } = await this.$api.general.businessList();
        this.logisticsList = data;
      } catch (err) {
        console.log("ajax getAjaxLogisticsList err", err);
      }
    },
    /**
     * 获取列表数据
     */
    getTableData() {
      this.loading = true;
      const params = {
        ...this.formData,
      };
      // TODO: 替换实际接口
      this.$api.general
        .buyerskusupplierList(params)
        .then((res) => {
          console.log(res, "获取数据");
          this.tableData = res.data.list || [];
          this.total = res.data.total || 0;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /**
     * 搜索
     */
    onHandleSearch() {
      this.formData.page = 1;
      this.currentPage = 1;
      this.getTableData();
    },
    /**
     * 重置
     */
    onHandleRefresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.currentPage = 1;
      this.getTableData();
    },
    /**
     * 导出
     */
    onHandleExport() {
      const params = {
        ...this.formData,
      };
      delete params.page;
      delete params.pageSize;
      this.disabledExport = true;
      // TODO: 替换实际导出接口
      //
      skusupplierexport(params)
        .then((res) => {
          console.log(res);
          this.goExportCenter();
          // downLoadFlowBlob(res, res?.filename);
        })
        .catch(() => {
          this.disabledExport = false;
        });
    },
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    /**
     * 新增
     */
    onHandleCreate() {
      this.dialogTitle = "新增";
      this.editForm = {
        ...this.editFormClone,
      };
      this.initAuthConfigList();
      this.editDialogVisible = true;
    },
    /**
     * 编辑
     */
    onHandleEdit(row) {
      console.log(row, "编辑");
      this.dialogTitle = "编辑";
      // 重置表单
      this.editForm = { ...this.editFormClone };
      this.editForm.supplier_id = row.supplier_id;
      this.editForm.buyer_id = row.buyer_id;
      console.log(this.editForm, "this.editForm");
      this.initAuthConfigList();
      this.$api.general
        .buyerskusupplierDetail({
          supplier_id: row.supplier_id,
          buyer_id: row.buyer_id,
        })
        .then((res) => {
          const data = res.data;
          console.log(data, "获取数据");

          // 基础信息
          this.editForm.supplier_name = data.title || "";
          this.editForm.buyer_name = data.buyer?.fullname || "";
          this.editForm.supplier_mobile = data.mobile || "";
          this.editForm.buyer_mobile = data.buyer?.mobile || "";
          this.editForm.on_sale_count = data.onsale_num || 0;
          this.editForm.off_sale_count = data.outsale_num || 0;
          this.editForm.slot_count = "";

          // 从接口数据动态构建权限配置列表
          const auth = data.auth || {};
          this.buildAuthConfigList(auth);
          console.log("this.authConfigList", this.authConfigList);
          // 设置坑位数（auth_type=1的权限项）
          const slotAuth = auth["1"];
          if (slotAuth) {
            this.editForm.slot_count =
              slotAuth.auth_value == 0 || Number(slotAuth.auth_value) > 0
                ? slotAuth.auth_value
                : "";
          }
        })
        .catch((err) => {
          console.log("获取数据失败", err);
        })
        .finally(() => {
          this.editDialogVisible = true;
        });
    },
    changeInput(val, item) {
      console.log("val", val.target._value);
      console.log("item", item);
      if (item.auth_type == 1 && val.target._value == 0) {
        this.editForm.slot_count = "";
      }
    },
    /**
     * 提交
     */
    onHandleSubmit() {
      const { id, slot_count } = this.editForm;

      // 构建权限数组
      const authList = this.authConfigList.map((item) => {
        let authValue;

        if (item.auth_type == 1) {
          // auth_type: 1 - 限制坑位
          // 选择"是"时，auth_value = 坑位数；选择"否"时，auth_value = 0
          authValue = item.value == 1 ? Number(slot_count) : -1;
        } else {
          // auth_type: 2-7 - 其他权限
          // auth_value: -1 不允许, 1 允许
          authValue = Number(item.value) > 0 ? 1 : -1;
        }

        return {
          auth_type: item.auth_type,
          auth_value: authValue,
          is_batch: item.applyAll ? 1 : 0,
          buyer_set: item.allowChange ? 1 : -1,
        };
      });

      const params = {
        supplier_id: this.editForm.supplier_id || "",
        buyer_id: this.editForm.buyer_id || "",
        auth: authList,
      };

      console.log("params", params);

      // TODO: 替换实际接口
      this.$api.general
        .buyerskusupplierUpdate(params)
        .then(() => {
          this.$message({
            type: "success",
            message: this.dialogTitle === "新增" ? "添加成功" : "修改成功",
          });
          this.editDialogVisible = false;
          this.getTableData();
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.formData.page = 1;
      this.formData.pageSize = val;
      this.currentPage = 1;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.formData.page = val;
      this.currentPage = val;
      this.getTableData();
    },
  },
};
</script>
<style lang="scss" scoped>
.supplier-manage {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  .mr30 {
    margin-right: 30px;
  }
  .mb30 {
    margin-bottom: 30px;
  }

  .title {
    background: #ffffff;
    padding: 13px 15px;
    box-sizing: border-box;
    display: flex;
  }

  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .contents {
    padding: 20px;
    box-sizing: border-box;
  }

  .success-text {
    color: #67c23a;
  }

  .danger-text {
    color: #f56c6c;
  }
}

// 弹窗样式
.supplier-dialog {
  ::v-deep .el-dialog {
    max-width: 1200px;
  }

  .contents {
    max-height: 600px;
    overflow-y: auto;
  }

  // 基础信息区域
  .info-section {
    background: #f5f7fa;
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 20px;

    .info-title {
      font-size: 14px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 12px;
    }

    .info-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;

      .info-item {
        display: flex;
        align-items: center;
        font-size: 13px;

        .info-label {
          color: #909399;
          margin-right: 8px;
          min-width: 70px;
        }

        .info-value {
          color: #303133;
          font-weight: 500;
        }
      }
    }
  }

  // 权限配置区域
  .auth-section {
    .auth-title {
      font-size: 14px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 16px;
    }

    .auth-list {
      display: flex;
      flex-direction: column;
      gap: 12px;

      .auth-item {
        background: #ffffff;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        padding: 12px 16px;
        transition: all 0.3s;

        &:hover {
          border-color: #409eff;
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.1);
        }

        .auth-row {
          display: flex;
          align-items: center;
          gap: 12px;

          .auth-name-label {
            font-size: 14px;
            font-weight: 500;
            color: #303133;
            min-width: 80px;
          }

          .auth-options {
            display: flex;
            align-items: center;
            gap: 24px;
            margin-left: auto;

            ::v-deep .el-checkbox__label {
              font-size: 13px;
            }
          }
        }

        .slot-row {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-top: 12px;
          padding-left: 80px;
          width: calc(100% - 80px);

          .slot-label {
            font-size: 14px;
            color: #303133;
            flex-shrink: 0;
          }

          .slot-input {
            flex: 1;
            max-width: 200px;
          }
        }
      }
    }
  }
}
</style>
